// src/pages/admin/alumni/DeleteAlumniPage.jsx

import React, { useEffect, useState } from "react";
import { useParams, useNavigate } from "react-router-dom";
import axios from "axios";
import { ArrowLeft, Trash2 } from "lucide-react";
import "./DeleteAlumniPage.css";

const API_BASE_URL = process.env.REACT_APP_BACKEND_API_URL;
const DEFAULT_AVATAR =
  "https://cdn-icons-png.flaticon.com/512/149/149071.png";

export default function DeleteAlumniPage() {
  const { id } = useParams();
  const navigate = useNavigate();

  const [alumni, setAlumni] = useState(null);
  const [reason, setReason] = useState("");
  const [loading, setLoading] = useState(false);
  const [currentUser, setCurrentUser] = useState("");

  // ===============================
  // Load Logged In User
  // ===============================
  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      setCurrentUser(user.fullname);
    }
  }, []);

  // ===============================
  // Fetch Alumni Basic Info
  // ===============================
  useEffect(() => {
    const fetchAlumni = async () => {
      try {
        const res = await axios.get(`${API_BASE_URL}/current-alumni/${id}`);
        setAlumni(res.data);
      } catch (err) {
        console.error("Failed to fetch alumni:", err.message);
      }
    };

    fetchAlumni();
  }, [id]);

  // ===============================
  // Handle Delete
  // ===============================
  const handleDelete = async () => {
    if (!reason.trim()) {
      return alert("Please provide a reason for deletion.");
    }

    const confirmDelete = window.confirm(
      "Are you sure you want to permanently delete this alumni?"
    );

    if (!confirmDelete) return;

    try {
      setLoading(true);

      await axios.delete(`${API_BASE_URL}/current-alumni/${id}`, {
        data: {
          deletedBy: currentUser,
          reasons: reason,
        },
      });

      alert("Alumni deleted successfully.");

      navigate(-1);
    } catch (err) {
      console.error("Delete error:", err.message);
      alert("Failed to delete alumni.");
    } finally {
      setLoading(false);
    }
  };

  if (!alumni) return <div className="delete-loading">Loading...</div>;

  const fullName = [
    alumni.title,
    alumni.firstName,
    alumni.middleName,
    alumni.lastName,
  ]
    .filter(Boolean)
    .join(" ");

  return (
    <div className="delete-page">
      {/* ======================
          ACTION BAR
         ====================== */}
      <div className="delete-action-bar">
        <button className="btn-back" onClick={() => navigate(-1)}>
          <ArrowLeft size={16} /> Back
        </button>
      </div>

      <div className="delete-card">
        <h2>Delete Alumni Record</h2>

        <div className="delete-profile">
          <img
            src={alumni.photo || DEFAULT_AVATAR}
            alt="Alumni"
            onError={(e) => (e.target.src = DEFAULT_AVATAR)}
          />
          <div>
            <p><strong>Name:</strong> {fullName}</p>
            <p><strong>Alumni ID:</strong> {alumni.alumniID}</p>
            <p><strong>Email:</strong> {alumni.email}</p>
            <p><strong>Mobile:</strong> {alumni.mobileNumbers?.[0]}</p>
          </div>
        </div>

        <div className="form-group">
          <label>Deleted By</label>
          <input type="text" value={currentUser} disabled />
        </div>

        <div className="form-group">
          <label>Reason for Deletion *</label>
          <textarea
            rows="4"
            placeholder="Enter reason for deletion..."
            value={reason}
            onChange={(e) => setReason(e.target.value)}
          />
        </div>

        <button
          className="btn-delete"
          onClick={handleDelete}
          disabled={loading}
        >
          <Trash2 size={16} />
          {loading ? "Deleting..." : "Confirm Delete"}
        </button>
      </div>
    </div>
  );
}
